import { HttpStatusCode } from '@angular/common/http';

export interface ApiErrorModel {
	apiErrorCode: number;
	httpStatusCode: HttpStatusCode;
	errorMessage: string;
}
